var React = require('react');

function ArrowLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"none","strokeWidth":"1"},React.createElement("g",{"fill":"#27316D"},React.createElement("g",null,React.createElement("g",null,React.createElement("g",{"transform":"translate(-235.000000, -656.000000) translate(135.000000, 530.000000) translate(0.000000, 118.000000) translate(109.000000, 12.000000) scale(-1, 1) translate(-109.000000, -12.000000) translate(100.000000, 8.000000)"},React.createElement("polygon",{"points":"12.414 8 12.414 4.993 0 4.993 0 3.039 12.414 3.039 12.414 0 17.407 4.004"})))))));
}

ArrowLeft.defaultProps = {"width":"18","height":"8","version":"1.1","viewBox":"0 0 18 8"};

module.exports = ArrowLeft;

ArrowLeft.default = ArrowLeft;
